(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2473],{

/***/ 28597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth",
      function () {
        return __webpack_require__(93442);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@styled-icons/ionicons-solid/LogoGoogle/LogoGoogle.esm.js
var LogoGoogle_esm = __webpack_require__(41386);
// EXTERNAL MODULE: ./node_modules/@styled-icons/ionicons-solid/LogoApple/LogoApple.esm.js
var LogoApple_esm = __webpack_require__(42310);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/shared-site/footer.tsx



var SiteFooter = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("footer", {
        className: "px-6 py-16 space-y-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-6xl mx-auto text-center flex flex-col items-center space-y-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "flex space-x-6 text-white text-opacity-80 hover:text-opacity-100 text-sm transition duration-300",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "https://reflect.app/discord",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Discord"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "https://twitter.com/reflectnotes",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Twitter"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/terms",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Terms"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/privacy",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Privacy"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-sm text-[#B1B2DD]",
                    children: "Reflect App, LLC. All rights reserved."
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./plugins/auth-state.ts
var auth_state = __webpack_require__(39189);
// EXTERNAL MODULE: ./plugins/index-cookie.ts
var index_cookie = __webpack_require__(50171);
// EXTERNAL MODULE: ./plugins/sleep.ts
var sleep = __webpack_require__(26494);
// EXTERNAL MODULE: ./services/api/auth.ts
var auth = __webpack_require__(52382);
// EXTERNAL MODULE: ./services/firebase.ts
var firebase = __webpack_require__(65622);
// EXTERNAL MODULE: ./services/firebase-packages.ts
var firebase_packages = __webpack_require__(62794);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./pages/auth.tsx













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Auth() {
    var router = (0,next_router.useRouter)();
    var redirect = router.query.redirect || null;
    var clientToken = router.query.client_token || null;
    var ref = (0,react.useState)(null), authStatus = ref[0], setAuthStatus = ref[1];
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(''), email = ref2[0], setEmail = ref2[1];
    var syncAuthState = function() {
        // We need to call this after user-interaction, otherwise
        // the localStorage doesn't persist
        (0,auth_state/* setAuthState */.oJ)({
            redirect: redirect === 'back' ? document.referrer : redirect,
            clientToken: clientToken,
            email: email
        });
    };
    var authWithProvider = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(provider) {
            var userCredential;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        syncAuthState();
                        ;
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return firebase_packages/* firebaseAuth.signInWithPopup */.lX.signInWithPopup(firebase/* auth */.I8, provider);
                    case 5:
                        userCredential = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        setAuthStatus('error');
                        setErrorMessage(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                        return _ctx.abrupt("return");
                    case 13:
                        if (userCredential === null || userCredential === void 0 ? void 0 : userCredential.user) {
                            _ctx.next = 16;
                            break;
                        }
                        setAuthStatus('error');
                        return _ctx.abrupt("return");
                    case 16:
                        (0,index_cookie/* setIndexCookie */.z)();
                        if (!clientToken) {
                            _ctx.next = 26;
                            break;
                        }
                        setAuthStatus('pending');
                        _ctx.next = 21;
                        return (0,auth/* createAccessToken */._A)(clientToken);
                    case 21:
                        _ctx.next = 23;
                        return (0,sleep/* default */.Z)(4000);
                    case 23:
                        setAuthStatus('success');
                        _ctx.next = 27;
                        break;
                    case 26:
                        if (redirect === 'back') {
                            router.back();
                        } else {
                            router.push('/app');
                        }
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function authWithProvider(provider) {
            return _ref.apply(this, arguments);
        };
    }();
    var authWithGoogle = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var provider;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        provider = new firebase_packages/* firebaseAuth.GoogleAuthProvider */.lX.GoogleAuthProvider();
                        firebase/* config.googleScopes.forEach */.vc.googleScopes.forEach(function(scope) {
                            return provider.addScope(scope);
                        });
                        provider.setCustomParameters({
                            prompt: 'select_account'
                        });
                        _ctx.next = 5;
                        return authWithProvider(provider);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function authWithGoogle() {
            return _ref.apply(this, arguments);
        };
    }();
    var authWithApple = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var provider;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        provider = new firebase_packages/* firebaseAuth.OAuthProvider */.lX.OAuthProvider('apple.com');
                        firebase/* config.appleScopes.forEach */.vc.appleScopes.forEach(function(scope) {
                            return provider.addScope(scope);
                        });
                        _ctx.next = 4;
                        return authWithProvider(provider);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function authWithApple() {
            return _ref.apply(this, arguments);
        };
    }();
    var authWithEmail = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setAuthStatus('email');
                        syncAuthState();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return firebase_packages/* firebaseAuth.sendSignInLinkToEmail */.lX.sendSignInLinkToEmail(firebase/* auth */.I8, email, {
                            handleCodeInApp: true,
                            url: "".concat(location.origin, "/auth/callback/email")
                        });
                    case 5:
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](2);
                        setAuthStatus('error');
                        setErrorMessage(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                        return _ctx.abrupt("return");
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    7
                ]
            ]);
        }));
        return function authWithEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetAuthStatus = function() {
        setAuthStatus(null);
        setErrorMessage(null);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col min-h-screen overflow-hidden bg-home-back text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-6xl mx-auto px-4 sm:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-16 pb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/static/home/footer-logo.png",
                                    width: 768 / 2,
                                    height: 480 / 2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-3xl mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center md:mt-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "min-w-72 min-h-80",
                                            children: [
                                                !authStatus && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-base font-medium text-white",
                                                                            children: "Sign in/up with"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mt-4 grid grid-cols-2 gap-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        onClick: function() {
                                                                                            return authWithGoogle();
                                                                                        },
                                                                                        title: "Sign in with Google",
                                                                                        className: "block w-full font-semibold text-white text-center bg-gradient-to-b from-home-button-lg to-home-button-rg rounded-lg drop-shadow-lg px-4 py-3 shadow-inner-white transform active:translate-y-0.5 active:opacity-90 transition duration-100 text-lg cursor-pointer",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoGoogle_esm/* LogoGoogle */.S, {
                                                                                            width: 28,
                                                                                            height: 28
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        onClick: function() {
                                                                                            return authWithApple();
                                                                                        },
                                                                                        title: "Sign in with Apple",
                                                                                        className: "block w-full font-semibold bg-gradient-to-b from-home-button-lg to-home-button-rg rounded-lg drop-shadow-lg px-4 py-3 shadow-inner-white transform active:translate-y-0.5 active:opacity-90 transition duration-100 text-lg cursor-pointer text-white text-center",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoApple_esm/* LogoApple */.Z, {
                                                                                            width: 28,
                                                                                            height: 28
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-10 relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "absolute inset-0 flex items-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "w-full border-t border-bluegray-800"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "relative flex justify-center text-base",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "px-3 py-1 bg-home-back rounded-lg text-white text-opacity-80",
                                                                                children: "or continue with"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-8",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                                onSubmit: function(event) {
                                                                    event.preventDefault();
                                                                    authWithEmail();
                                                                },
                                                                className: "space-y-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "mt-1",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                value: email,
                                                                                onChange: function(event) {
                                                                                    return setEmail(event.currentTarget.value);
                                                                                },
                                                                                placeholder: "your@email.com",
                                                                                name: "email",
                                                                                type: "email",
                                                                                autoComplete: "email",
                                                                                required: true,
                                                                                className: "appearance-none block w-full px-4 py-3 rounded-lg shadow-sm placeholder-bluegray-400 focus:outline-none bg-bluegray-900 bg-opacity-50 border border-bluegray-800 focus:border-purple-400 focus:ring focus:ring-purple-500 focus:ring-opacity-50 transition duration-300 text-base text-center"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            type: "submit",
                                                                            className: "block w-full font-semibold text-white bg-gradient-to-b from-home-button-lg to-home-button-rg rounded-lg drop-shadow-lg px-4 py-2 shadow-inner-white transform active:translate-y-0.5 active:opacity-90 transition duration-100 text-lg",
                                                                            children: "Continue"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                authStatus === 'pending' && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "text-center pt-10 text-2xl",
                                                    children: "Just one second..."
                                                }),
                                                authStatus === 'email' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: "text-center pt-10 text-4xl",
                                                            children: "You've got mail"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center pt-10 text-2xl",
                                                            children: "We've emailed you a secure login link."
                                                        })
                                                    ]
                                                }),
                                                authStatus === 'success' && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-3xl text-green-500",
                                                            children: "Signed in successfully"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center text-xl",
                                                            children: "You may close this window."
                                                        })
                                                    ]
                                                }),
                                                authStatus === 'error' && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-3xl text-red-500",
                                                            children: "Error signing in"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-center text-xl",
                                                            children: errorMessage || 'Something went wrong.'
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return resetAuthStatus();
                                                                },
                                                                className: "w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-purple-600 hover:bg-purple-500 transition duration-300 focus:outline-none focus:ring",
                                                                children: "Try again"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 flex items-center justify-center sm:hidden bg-white px-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center space-y-5 text-black max-w-52",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Please use our iOS app for the best mobile experience."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-blue-500",
                                href: "https://reflect.app/testflight",
                                children: "reflect.app/testflight"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteFooter, {})
        ]
    }));
};


/***/ }),

/***/ 39189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oJ": function() { return /* binding */ setAuthState; },
/* harmony export */   "oH": function() { return /* binding */ getAuthState; }
/* harmony export */ });
/* unused harmony export AUTH_STATE_KEY */
var AUTH_STATE_KEY = 'auth-state';
var setAuthState = function(state) {
    try {
        localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(state));
    } catch (error) {
        console.error(error);
    }
};
var getAuthState = function() {
    if (typeof localStorage != 'object') return null;
    try {
        var state = localStorage.getItem(AUTH_STATE_KEY);
        return state ? JSON.parse(state) : {};
    } catch (error) {
        console.error(error);
        return null;
    }
};


/***/ }),

/***/ 50171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ setIndexCookie; },
/* harmony export */   "N": function() { return /* binding */ useIndexCookie; }
/* harmony export */ });
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var setIndexCookie = function() {
    var oneYear = 30 * 24 * 60 * 60 * 360;
    // Ensure that requests to the naked
    // domain go straight to the app
    (0,nookies__WEBPACK_IMPORTED_MODULE_0__.setCookie)(null, 'indexApp', '1', {
        maxAge: oneYear,
        path: '/'
    });
};
var useIndexCookie = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIndexCookie();
    }, []);
};


/***/ }),

/***/ 52382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bm": function() { return /* binding */ startAuthProcess; },
/* harmony export */   "_A": function() { return /* binding */ createAccessToken; },
/* harmony export */   "w7": function() { return /* binding */ signOut; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_firebase_packages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62794);
/* harmony import */ var plugins_generate_id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8636);
/* harmony import */ var services_electron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16090);
/* harmony import */ var services_firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65622);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49752);
/* harmony import */ var plugins_array_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82905);








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var startAuthProcess = function() {
    var clientToken = (0,plugins_generate_id__WEBPACK_IMPORTED_MODULE_6__/* .generateId */ .O)();
    var clientTokensRef = services_firebase_packages__WEBPACK_IMPORTED_MODULE_2__/* .firestore.collection */ .RZ.collection(services_firebase__WEBPACK_IMPORTED_MODULE_4__.db, 'client-tokens');
    var clientTokenDoc = services_firebase_packages__WEBPACK_IMPORTED_MODULE_2__/* .firestore.doc */ .RZ.doc(clientTokensRef, clientToken);
    var unsubscribe = services_firebase_packages__WEBPACK_IMPORTED_MODULE_2__/* .firestore.onSnapshot */ .RZ.onSnapshot(clientTokenDoc, function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(snapshot) {
            var ref, accessToken;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (snapshot === null || snapshot === void 0 ? void 0 : snapshot.exists()) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        accessToken = (ref = snapshot.data()) === null || ref === void 0 ? void 0 : ref.access_token;
                        if (!accessToken) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return services_firebase_packages__WEBPACK_IMPORTED_MODULE_2__/* .firebaseAuth.signInWithCustomToken */ .lX.signInWithCustomToken(services_firebase__WEBPACK_IMPORTED_MODULE_4__/* .auth */ .I8, accessToken);
                    case 7:
                        unsubscribe();
                        services_electron__WEBPACK_IMPORTED_MODULE_3__/* .electron */ .u === null || services_electron__WEBPACK_IMPORTED_MODULE_3__/* .electron */ .u === void 0 ? void 0 : services_electron__WEBPACK_IMPORTED_MODULE_3__/* .electron.showWindow */ .u.showWindow();
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(snapshot) {
            return _ref.apply(this, arguments);
        };
    }());
    return clientToken;
};
var createAccessToken = function() {
    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(clientToken) {
        var idToken;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .getIdToken */ .lI)();
                case 2:
                    idToken = _ctx.sent;
                    return _ctx.abrupt("return", fetch('/api/auth/client-token', {
                        method: 'POST',
                        headers: {
                            Authorization: "Firebase ".concat(idToken),
                            'Content-Type': 'application/json; charset=utf-8'
                        },
                        body: JSON.stringify({
                            client_token: clientToken,
                            id_token: idToken
                        })
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createAccessToken(clientToken) {
        return _ref.apply(this, arguments);
    };
}();
var listAllIndexedDatabases = function() {
    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var databases;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(typeof window.indexedDB != 'undefined' && typeof indexedDB.databases === 'function')) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 3;
                    return indexedDB.databases();
                case 3:
                    databases = _ctx.sent;
                    return _ctx.abrupt("return", databases.map(function(db1) {
                        return db1.name;
                    }).filter(plugins_array_fns__WEBPACK_IMPORTED_MODULE_7__/* .notEmpty */ .D));
                case 7:
                    return _ctx.abrupt("return", []);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function listAllIndexedDatabases() {
        return _ref.apply(this, arguments);
    };
}();
var deleteAllIndexedDatabases = function() {
    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var databases;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return listAllIndexedDatabases();
                case 2:
                    databases = _ctx.sent;
                    _ctx.next = 5;
                    return Promise.all(databases.map(function(db2) {
                        return indexedDB.deleteDatabase(db2);
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteAllIndexedDatabases() {
        return _ref.apply(this, arguments);
    };
}();
var signOut = function() {
    var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, _resetDatabases, resetDatabases, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, _resetDatabases = ref.resetDatabases, resetDatabases = _resetDatabases === void 0 ? true : _resetDatabases;
                    _ctx.next = 3;
                    return services_firebase__WEBPACK_IMPORTED_MODULE_4__/* .auth.signOut */ .I8.signOut();
                case 3:
                    (0,nookies__WEBPACK_IMPORTED_MODULE_1__.destroyCookie)(null, 'indexApp');
                    if (!resetDatabases) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 7;
                    return deleteAllIndexedDatabases();
                case 7:
                    localStorage.clear();
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function signOut() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 16090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_electron; },
  "u": function() { return /* reexport */ electron; }
});

;// CONCATENATED MODULE: ./services/electron/global.ts
var electron =  true ? window.electron : 0;

;// CONCATENATED MODULE: ./services/electron/index.ts


/* harmony default export */ var services_electron = (electron);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7611,2956,2016,8278,3662,78,3714,4219,2432,2440,7215,5453,461,5675,7673,9060,8637,734,9987,9241,9774,2888,179], function() { return __webpack_exec__(28597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);